import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../components/CustomButtons/Button";
import Search from '../../assets/img/search_icon2x.png'
import Grid from '@material-ui/core/Grid'
import CardBody from "../../components/Card/CardBody";
import Card from "../../components/Card/Card";
import CardText from "../../components/Card/CardText";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem";
import CardHeader from "../../components/Card/CardHeader";
import LookupSearch1 from "./LookupSearch1";
import LookupSearch2 from "./LookupSearch2";
import Menu from '../Menu'
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputBase from '@material-ui/core/InputBase';
import drop from '../../assets/img/dropdown_arrow.png'
import Datetime from 'react-datetime';
import '../../assets/css/Orderlook.css'

const useStyles = (theme) => ({
  card1: {
    width: "95%",
    boxShadow: '0px 0px 5px 0px #d6d6d6'
  },
  heading: {
    marginLeft: "10%",
    fontSize: "",
    color: "gray",
    marginTop: "9%",
    fontWeight: "390"
  },
  cardTitle: {
    fontWeight: "bold",
    fontSize: "29px",
    paddingRight: "93px",
    marginTop: "2px",
    height: "50px",
    paddingLeft: "10px",
    paddingTop: "10px",
    marginLeft: "20px",
    [theme.breakpoints.down('sm')]: {
      height: "7vw",
      fontSize: "19px"
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: "10px"
    }
  },
  icon: {
    marginLeft: "10%",
  },
  card2: {
    width: "95%",
    boxShadow: '0px 0px 5px 0px #d6d6d6'
  },
  select: {
    width: '18vw',
    height: "28px",
    marginLeft: "70px",
  },
  select1: {
    width: '20vw',
    height: "28px",
    marginTop: theme.spacing(3),
    border: 'none',
    boxShadow: '0px 0px 5px 0px #d6d6d6',
    [theme.breakpoints.down('xs')]: {
      width: '40vw',
    },
    [theme.breakpoints.down('sm')]: {
      width: '37vw',
    },
    [theme.breakpoints.down('xs')]: {
      width: '37vw',
      marginLeft: theme.spacing(1.3),
    }
  },
  label1: {
    fontSize: "25px",
    [theme.breakpoints.down('md')]: {
      fontSize: "1.9vw",
      color: 'yellow'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px',
      color: 'red'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '23px',
      color: 'blue'
    },
  },
  button: {
    alingSelf: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    color: 'white',
    backgroundColor: '#04ab23',
    textTransform: 'none',
    fontFamily: 'Roboto-Medium',
    boxShadow: "none",
    borderRadius: 1,
    width: '170px',
    fontSize: "20px",
    '&:hover': {
      backgroundColor: '#04ab23'
    },
    '&:focus': {
      outline: 'none',
      backgroundColor: '#04ab23'
    },
  },
  body: {
    displey: 'flex',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    alingItems: 'center',
    width: '99%',
    justifyItems: 'center'
  },
  header: {
    fontSize: "25px",
    color: "'#333333'",
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
    },
  }
});

const BootstrapInput = withStyles((theme) => ({
  root: {
      'label + &': {
          marginTop: theme.spacing(3),
      },
  },
  input: {
      borderRadius: 4,
      position: 'relative',
      width: '18vw',
      marginTop: '8px',
      boxShadow: '0px 0px 5px 0px #d6d6d6',
      backgroundColor: theme.palette.background.paper,
      border: 'none',
      padding: '1px 26px 7px 12px',
      [theme.breakpoints.down('xs')]: {
          width: '40vw',

      },
      [theme.breakpoints.down('sm')]: {
          width: '30vw',
      }
  },

}))(InputBase);

class OrderLookup extends React.Component {
  
  state = {
    selected_order_lookup: "",
    selected_lender_lookup: "",
    order_value: "",
    lender_value: "",
    input_type: "text",
    statusFilterChange: false,
  };

  orderTapped = () => {
    if(/\d{4}-\d{2}-\d{2}/g.test(this.state.order_value)){
      const dateArray = this.state.order_value.split("-");
      const formattedDate = `${dateArray[1]}/${dateArray[2]}/${dateArray[0]}`;
      return this.props.history.push({  
        pathname: '/OrderLookupResult',
        state: { look_up: true },
        lookupData: {
          search_text: formattedDate,
          key_name: this.state.selected_order_lookup,
          isStatusProvided: 0,
        },
        lookupType: "Order"
      });
    }
    this.props.history.push({  
      pathname: '/OrderLookupResult',
      state: { look_up: true },
      lookupData: {
        search_text: this.state.order_value.trim(),
        key_name: this.state.selected_order_lookup,
        isStatusProvided: 0,
      },
      lookupType: "Order"
    });
  }

  lenderTapped = () => {
    this.props.history.push({
      pathname: '/OrderLookupResult',
      state: { look_up: true },
      lookupData: {
        search_text: this.state.lender_value.trim(),
        key_name: this.state.selected_lender_lookup
      },
      lookupType: "Lender"
    });
  }

  handleChange = (e) => {
    e.preventDefault();
    switch(e.target.id){
      case "lender":
        this.setState({lender_value : e.target.value})
        break;
      case "order":
      case "latest_status":
        this.setState({order_value : e.target.value})
        break;
      // case "dates":
      //   this.setState({ order_value: e.format('MM/DD/YYYY') })
      //   break;
      default: 
        break;
    }
  };

  handleDateChange = (e) => {
    return this.setState({ order_value: e.format('MM/DD/YYYY') })
  }

  selectedOrderSearch = (key_name) => {
    if(key_name.includes("date")){
      return this.setState({ input_type : 'date', selected_order_lookup : key_name, statusFilterChange: false })
    }
    if(key_name === 'latest_status'){
      return this.setState({ selected_order_lookup : key_name, statusFilterChange: true })
    }
    this.setState({input_type : 'text', selected_order_lookup : key_name, statusFilterChange: false})
  }

  selectedLenderSearch = (key_name) => {
    this.setState({selected_lender_lookup : key_name})
  }

  render() {
    const { classes } = this.props;
    const { selected_order_lookup, selected_lender_lookup, order_value, lender_value, input_type, statusFilterChange } = this.state;
    return (
      <div>
        <Menu />
        <div className="mdata">
          <Grid container>
            <Grid item>
              <h2 className="mtextOpenOrder">
                Lookup
              </h2>
            </Grid>
          </Grid>
          <GridContainer>
            <GridItem xs={12} md={6}>
              <div className={classes.div1}>
                <Card className={classes.card1}>
                  <CardHeader color="success" text>
                    <CardText color="success">
                      <h4 className={classes.cardTitle}>Order Information </h4>
                    </CardText>
                  </CardHeader>
                  <CardBody className={classes.body}>
                    <LookupSearch1 
                      selectedOrderSearch = {this.selectedOrderSearch}
                    />
                    <Grid container style={{ display: 'flex' }}>
                      <Grid item xs={4}>
                        <h3 className={classes.header}>
                          Order Lookup:
                        </h3>
                      </Grid>
                      <Grid item xs={8}>
                        {!statusFilterChange && input_type === "text" && (
                          <input 
                            name="order" 
                            id="order" 
                            type="text" 
                            className={classes.select1} 
                            onChange={this.handleChange}
                          />
                        )}
                        {!statusFilterChange && input_type === "date" && (
                          <Datetime
                            id="dates"
                            className="filter-date-picker orderlook"
                            closeOnSelect
                            timeFormat={false}
                            initialValue={new Date()}
                            onChange={this.handleDateChange}
                          />
                        )}
                        {statusFilterChange && (
                          <FormControl className={classes.margin} style={{marginTop: '20px'}}>
                            <NativeSelect
                              name="latest_status"
                              id="latest_status"
                              value={order_value}
                              onChange={this.handleChange}
                              input={<BootstrapInput />}
                              IconComponent={(props) => (
                                  <img alt={"qwe"} {...props} src={drop} style={{ height: '12px', marginRight: '4%', marginTop: '3.4%' }} />
                              )}
                            >
                              <option aria-label="None" value="" disabled>Select Status</option>
                              <option value="open">Open</option>
                              <option value="hold">Hold</option>
                              <option value="completed">Completed</option>
                            </NativeSelect>
                          </FormControl>
                        )}
                      </Grid>
                    </Grid>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                      <Button
                        variant="contained"
                        className={classes.button}
                        endIcon={<img src={Search} alt="..." style={{ width: '65%', height: '65%' }} />}
                        onClick={this.orderTapped}
                        disabled={!selected_order_lookup || !order_value}
                      >
                        Search
                    </Button>
                    </div>
                   </CardBody>
                </Card>
              </div>
            </GridItem>

            <GridItem xs={12} md={6}>
              <div className={classes.div2}>
                <Card className={classes.card2}>
                  <CardHeader color="success" text>
                    <CardText color="success">
                      <h4 className={classes.cardTitle}>Lender Information </h4>
                    </CardText>
                  </CardHeader>
                  <CardBody className={classes.body}>
                    <LookupSearch2 selectedLenderSearch = {this.selectedLenderSearch}/>

                    <Grid container style={{ display: 'flex' }}>
                      <Grid item >
                        <div style={{ display: 'flex', flexDirection: 'row', }}>
                          <Grid item xs={5}>
                            <h3 className={classes.header}>
                              Lender Lookup:
                            </h3>
                          </Grid>
                          <Grid item xs={7}>
                            <input name="lender" id="lender" className={classes.select1} onChange={this.handleChange}  />
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>

                    <div style={{ alignItems: 'center', justifyContent: 'center', justifyItems: 'center', display: 'flex' }}>
                      <Button
                        variant="contained"
                        className={classes.button}
                        endIcon={<img src={Search} alt="..." style={{ width: '65%', height: '65%' }} />}
                        onClick={this.lenderTapped}
                        disabled={!selected_lender_lookup || !lender_value}
                      >
                        Search
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}
export default withStyles(useStyles, { withTheme: true })(OrderLookup);